import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/lt';

dayjs.locale('lt');
dayjs.extend(timezone);
dayjs.tz.setDefault('Europe/Vilnius');

const todayStart = dayjs().startOf('day').format();
const todayEnd = dayjs().endOf('day').format();
const week = dayjs().startOf('week').format();
const month = dayjs().startOf('month').format();
const year = dayjs().startOf('year').format();
const tenYears = dayjs().subtract(10, 'year').format();
const todayMinusYear = dayjs().startOf('day').subtract(1, 'year').format();

export type DateRange = { from: string; to: string };

const dateRangeToday: DateRange = { from: todayStart, to: todayEnd };
const dateRangeOngoingWeek: DateRange = { from: week, to: todayEnd };
const dateRangeOngoingMonth: DateRange = { from: month, to: todayEnd };
const dateRangeOngoingYear: DateRange = { from: year, to: todayEnd };
const dateRangeYear: DateRange = { from: todayMinusYear, to: todayEnd };
const dateRangeLastTenYears: DateRange = { from: tenYears, to: todayEnd };

export { dateRangeToday, dateRangeOngoingWeek, dateRangeOngoingMonth, dateRangeOngoingYear, dateRangeYear, dateRangeLastTenYears };
